// extracted by mini-css-extract-plugin
export default {"searchCollapse":"SearchCollapse_searchCollapse__VblFC"};